import React from "react";
import { Box } from "@mui/material";
import SocialIcons from "../SocialIcons/SocialIcons";
import "./footer.css";
import { useNavigate } from "react-router";

const angies1 = require("../../assets/images/angies2014.png");
const angies2 = require("../../assets/images/angies2015.png");
const angies3 = require("../../assets/images/angies2016.png");
const angies4 = require("../../assets/images/angies2017.png");

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      className="footer-box"
      component="footer"
      data-nosnippet
    >
      <div className="footer-bg-box">
        <div className="img-box">
          <img className="footer-img" src={angies1} alt="Angie's List 2014" />
          <img className="footer-img" src={angies2} alt="Angie's List 2015" />
          <img className="footer-img" src={angies3} alt="Angie's List 2016" />
          <img className="footer-img" src={angies4} alt="Angie's List 2017" />
        </div>
        <div className="footer-social">
          <SocialIcons />
        </div>
        <span className="footer-hdr">Est. 2012</span>
        <div className="footer-privacy-tos-box">
          <button
            onClick={() => navigate("/privacy-policy")}
            className="footer-btn"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => navigate("/terms-of-service")}
            className="footer-btn"
          >
            Terms of Service
          </button>
        </div>
      </div>
      <div
        className="footer-hidden-login"
        onClick={() => navigate(`/login-portal`)}
      ></div>
    </Box>
  );
};

export default Footer;
